import React, { FC } from "react";
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from "recharts";

import { ColorPrimary } from "@intelligems/ig-theme";

import {
  getHistogramData,
  useGraphValueFormatter,
} from "../../../api/formatters/dashboard";
import theme from "../../../theme";
import { HistogramMetricData } from "../../../types/analytics";

import { GraphConfig } from "./Utils/graphConfigs";
import {
  CustomizedAxisTick,
  CustomResponsiveContainer,
} from "./Utils/graphStyleCustoms";

interface HistogramGraphProps {
  groupMetricData: HistogramMetricData[];
  config: GraphConfig;
  aovFilterChoice: string;
}

export const HistogramGraph: FC<HistogramGraphProps> = ({
  config,
  groupMetricData,
  aovFilterChoice,
}) => {
  const allData = getHistogramData(groupMetricData, aovFilterChoice);
  const graphValueFormatter = useGraphValueFormatter();

  return (
    <CustomResponsiveContainer height={300} width="100%">
      <BarChart
        style={{ marginLeft: -24 }}
        margin={{
          top: 5,
          bottom: 5,
        }}
        data={allData}
      >
        <CartesianGrid
          style={{ stroke: theme.palette.disabled.light }}
          vertical={false}
        />
        <XAxis
          interval={"preserveEnd"}
          tick={(props: any) => {
            return (
              // @ts-ignore
              <CustomizedAxisTick
                props={props}
                groupMetricData={groupMetricData}
                graphValueFormatter={graphValueFormatter}
                config={config}
              />
            );
          }}
          axisLine={{ stroke: theme.palette.disabled.light }}
          tickLine={false}
          dataKey={(ev) => `${ev.bucket}`}
        />
        <YAxis
          allowDecimals={false}
          type={"number"}
          style={{ fontFamily: theme.typography.fontFamily, fontSize: 14 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value: any) =>
            graphValueFormatter(true, value, config)!
          }
        />
        <Tooltip
          contentStyle={{
            fontFamily: theme.typography.fontFamily,
            borderRadius: 5,
            fontSize: 14,
            backgroundColor: "rgba(97, 97, 97, 0.92)",
            color: "#FFF",
            border: "1px solid transparent",
          }}
          itemStyle={{ color: "#FFF" }}
          formatter={(value: any) => graphValueFormatter(false, value, config)!}
          labelFormatter={(value: any) =>
            graphValueFormatter(false, value, config)
          }
        />
        <Bar
          name={config.title[0]}
          radius={[5, 5, 0, 0]}
          dataKey="bucketCount"
          fill={ColorPrimary.light2}
          stackId="a"
        />
      </BarChart>
    </CustomResponsiveContainer>
  );
};
